<template>
  <div>
    <v-row id="router" class="ma-0 pa-0 pb-6" :style="viewStyle">
      <div id="listTable">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr class="text-center">
                <th class="text-center">查看</th>
                <th>員工編號</th>
                <th>薪資年月</th>
                <th>應發合計</th>
                <th>應扣合計</th>
                <th>實發金額</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index" id="table_body">
                <td class="text-center" style="min-width:75px">
                  <v-avatar color="#BEE7FE" size="30" tile @click="redirectPath('/payrollHistoryPage/', data.id)">
                    <v-icon color="#2A7EBE">icon-form_edit_tap</v-icon>
                  </v-avatar>
                </td>
                <td style="min-width:100px"><h4 class="content">{{data.userId}}</h4></td>
                <td style="min-width:100px"><h4 class="content">{{data.yearMonth}}</h4></td>
                <td style="min-width:100px"><h4 class="content">{{data.totalPayable}}</h4></td>
                <td style="min-width:100px"><h4 class="content">{{data.totalDeduction}}</h4></td>
                <td style="min-width:100px"><h4 class="content">{{data.netPay}}</h4></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-row>
    <v-footer id="footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large outlined color="#002C61" @click="redirectPath('/frontPage')">返回</v-btn>
      </div>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'PayrollHistoryList',
  components: {},
  mounted(){
    if(this.$route.query.page){
      this.pagination.page = parseInt(this.$route.query.page)
      this.getDataset()
    }else{
      this.getDataset()
    }
  },
  data:() => ({
    viewStyle:{},
    keyword:'',
    datasets: [],
    pagination:{page:1,totalPage:10,totalCount:10},
    orderBy:'id',
    direction:'desc',

    displayMode:'',
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{},
  computed:{},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-140 + 'px'}
      if(window.innerWidth >= 960){
        this.displayMode = 0
      } else {
        this.displayMode = 1
      }
    },
    redirectPath(path, id){
      this.$router.push({path: path, query: {
        id: id,
        userIdSel: sessionStorage.getItem('manageMemberUserId'),
        pageInfo: '/payrollHistoryList',
        page: this.pagination.page
      }})
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/pmAccountingMonthDetailArchivedByUser',
        params: {
          'page':self.pagination.page,
          'limit':10,
          'orders':self.orderBy + ':' + self.direction,
          'status': '',
          'keyword':self.keyword != ''? self.keyword: null, 
          'userId':sessionStorage.getItem('manageMemberUserId'),
        },
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data.records
      }).catch(()=>{
      }).finally(()=>{
      })
    },
  }
}
</script>

<style>
  @media (min-width: 960px) {
    .search-bar-min {
      display: none !important;
    }
  }
  @media (max-width: 959px) {
    .search-bar-max, .pagination-max {
      display: none !important;
    }
  }
</style>